import React, { useState } from 'react';
import { 
  Accordion, 
  AccordionSummary, 
  AccordionDetails, 
  Typography, 
  Container, 
  Box,
  Divider
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './FAQ.css';

const FAQ: React.FC = () => {
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const faqItems = [
    {
      question: "How can I access my monthly billing statements?",
      answer: "Monthly billing statements are emailed from OptiMedHealth@vbasoftware.com. Statements are also available on the Employer Portal for your convenience under Invoices."
    },
    {
      question: "What should I do if I have difficulties receiving monthly statements via email?",
      answer: "Check your junk and spam folders, get with your IT department to ensure that billing_support@optimedhealth.com and OptiMedHealth@vbasoftware.com are whitelisted (safe sender list). If none of the above troubleshooting steps are successful, please contact billing_support@optimedhealth.com or your dedicated biller."
    },
    {
      question: "What are the different payment methods available for billing?",
      answer: "OptiMedHealth offers three principal payment methods: Automatic ACH Payment, Single Electronic ACH Payment (One-Time), and Payment by Check. Each method has specific instructions and processes listed below."
    },
    {
      question: "How do I enroll in the Automatic ACH Payment program (Monthly ACH)?",
      answer: "To enroll, complete the ACH Authorization form which can be found on the employer portal. The direct link to the payments portion of this site is https://www.optimedhealthportal.com/payments. Invoices are provided around the 20th of the month, and funds are drafted on the 3rd business day of the following month."
    },
    {
      question: "How can I make a single electronic ACH payment?",
      answer: "Submit your banking information via the secure online form which can be found on the employer portal. The direct link to the payments portion of this site is https://www.optimedhealthportal.com/payments. The designated amount you enter will be drafted within two business days. Additionally, you may choose to pay via Electronic Check. To do so please visit the employer portal."
    },
    {
      question: "Where do I mail my check for payment?",
      answer: "Mail checks to the designated Lockbox address specified in your employer application and associated with your insurance carrier. Ensure checks are made payable to 'United Group Programs, Inc.' The addresses for each carrier are listed on our website. For overnight payments, use: United Group Programs, Inc., Include Carrier (Example: Nationwide Groups or Chubb Groups), 5505 N Cumberland Ave, Suite 307, Chicago, IL 60656-1471."
    },
    {
      question: "What should I do if I find discrepancies on my invoice?",
      answer: "Notify Billing Support of the issue you are having at billing_support@optimedhealth.com. The requested changes will be processed, and any credits or debits will appear on the following invoice."
    },
    {
      question: "What is the process for submitting enrollments and terminations?",
      answer: "Submit enrollments and terminations before the 19th of the month to reflect on the upcoming monthly billing statement. Submissions after the 19th will be applied to the next month's statement. Please submit all enrollment changes via the employer portal or via email to billing_spport@optimedhealth.com."
    },
    {
      question: "How can I contact the billing support staff?",
      answer: "For any billing-related questions, email billing_support@optimedhealth.com. Representatives are available to assist with your inquiries. If this is an immediate issue and the group contact needs to speak to a billing representative on the phone, please contact our support team."
    }
  ];

  return (
    <Container maxWidth="md" className="faq-container">
      <Box sx={{ my: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom align="center">
          Billing FAQs for Customer Service Agents
        </Typography>
        <Typography variant="subtitle1" gutterBottom align="center" sx={{ mb: 4 }}>
          Find answers to common billing questions
        </Typography>
        
        <Divider sx={{ mb: 4 }} />
        
        {faqItems.map((item, index) => (
          <Accordion 
            key={index} 
            expanded={expanded === `panel${index}`} 
            onChange={handleChange(`panel${index}`)}
            className="faq-accordion"
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel${index}-content`}
              id={`panel${index}-header`}
            >
              <Typography variant="h6">{item.question}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>{item.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Container>
  );
};

export default FAQ; 